import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TermsAndConditions from './TermsAndConditions';
import ProductCategories from './productscategories';
import ProtectedRoute from './routes/ProtectedRoute';
import ProdMatch from './productmatches';
import ProdList from './productlist';
import ProdCategories from './productscategories';
import PrivateModeScreen from './PrivateModeScreen';
import { onDemoModeRestricted } from './authSession';

function App() {
  // SHOP-209: once any backend call reports demo_mode_restricted, this
  // takes over the entire app - including routes like /terms - rather than
  // just the screen that happened to be showing when it fired.
  const [isDemoModeRestricted, setIsDemoModeRestricted] = useState(false);

  useEffect(() => onDemoModeRestricted(() => setIsDemoModeRestricted(true)), []);

  if (isDemoModeRestricted) {
    return <PrivateModeScreen />;
  }

  return (
    <Routes>
      <Route path="/terms" element={<TermsAndConditions />} />

      <Route
        path="/categories"
        element={
          <ProtectedRoute>
            <ProductCategories />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/categories" replace />} />
    </Routes>
  );
}

export default App;
